import { j as e, I as l, d as o } from "./IconTemplate-c24f5ddb.mjs";
import "react";
const r = (a) => /* @__PURE__ */ e(l, { ...a, name: a.name || "Close", viewBox: "0 0 1024 1024", children: /* @__PURE__ */ e(
  "path",
  {
    d: "M865.83 926.17a42.67 42.67 0 1 0 60.36-60.34L572.35 512l353.84-353.83a42.67 42.67 0 0 0-60.36-60.34L512 451.67 158.19 97.83a42.67 42.67 0 0 0-60.36 60.34L451.67 512 97.83 865.83a42.67 42.67 0 1 0 60.34 60.34L512 572.33z",
    fill: "currentColor",
    fillOpacity: "0.9"
  }
) });
r.defaultProps = o;
export {
  r as default
};
